import { createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('transformSql');

export const GET_TRANSFORM_SQL = apiType('GetTransformSql');
